import { Injectable } from '@angular/core';
import { HttpDataService } from '../shared/http/http-data.service';

@Injectable()
export class MailDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public unsubscribe(deconid:string, ukey:string):Promise<void> {
    return this.httpDataService.doPOST(
      'rest/mailsubscriptions/unsubscribe',
      undefined,
      {
        deconid,
        ukey
      },
      'Unsubscribing...',
      'Error to unsubscribe'
    );
  }

  public resubscribe(deconid:string, ukey:string):Promise<void> {
    return this.httpDataService.doPOST(
      'rest/mailsubscriptions/resubscribe',
      undefined,
      {
        deconid,
        ukey
      },
      'Resubscribing...',
      'Error to resubscribe'
    );
  }

  public unsubscribereason(deconid:string, ukey:string, reason:string):Promise<void> {
    return this.httpDataService.doPOST(
      'rest/mailsubscriptions/unsubscribereason',
      undefined,
      {
        deconid,
        ukey,
        reason
      },
      'Sending reason...',
      'Error sending reason'
    );
  }
}